'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Once = undefined;

var _lodash = require('lodash');

var _DecorateInstance = require('./DecorateInstance');

var Once = exports.Once = (0, _DecorateInstance.DecorateInstance)(_lodash.once);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9PbmNlLmpzIl0sIm5hbWVzIjpbIk9uY2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFTyxJQUFNQSxzQkFBTyxxREFBYiIsImZpbGUiOiJPbmNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtvbmNlfSBmcm9tICdsb2Rhc2gnO1xuaW1wb3J0IHtEZWNvcmF0ZUluc3RhbmNlfSBmcm9tICcuL0RlY29yYXRlSW5zdGFuY2UnO1xuXG5leHBvcnQgY29uc3QgT25jZSA9IERlY29yYXRlSW5zdGFuY2Uob25jZSk7XG4iXX0=